import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiGet } from 'services/api';
import {
  IBulkUploadCatalogApi,
  IBulkUploadOrderApi,
  IBulkUploadQuotesApi
} from 'views/bulkUpload/TypeOfCharge/TypeOfCharge.types';

const { REACT_APP_CATALOG, REACT_APP_SUBSCRIPTION } = process.env;

export const getCatalogHistory = async (): Promise<IBulkUploadCatalogApi[]> => {
  return apiGet<AxiosRequestConfig, IBulkUploadCatalogApi[]>(`${REACT_APP_CATALOG}bulk-upload/history/1`)
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getOrdersHistory = async (): Promise<IBulkUploadOrderApi[]> => {
  return apiGet<AxiosRequestConfig, IBulkUploadOrderApi[]>(`${REACT_APP_SUBSCRIPTION}/bulk-upload/history`)
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getQuotesHistory = async (): Promise<IBulkUploadQuotesApi[]> => {
  return apiGet<AxiosRequestConfig, IBulkUploadQuotesApi[]>(`${REACT_APP_CATALOG}bulk-upload/history/2`)
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};
